import {
  INITIAL_STATE,
  resetSharepointSearch,
  setNextSkipToken,
  setPath,
  setSharepointData,
} from "../sharepointSlice";
import { fetchSharepointSites } from "./fetchSharepointSites";

export const reloadSharepointRoot = () => (dispatch) => {
  dispatch(setPath(INITIAL_STATE.path));
  dispatch(resetSharepointSearch());
  dispatch(setSharepointData([]));
  dispatch(setNextSkipToken(null));
  dispatch(fetchSharepointSites());
};
